import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CURRENCIES } from '../../assets/strings/translations';
import { ICountry } from '../models/countries';
import { environment } from 'src/environments/environment';
import { IResponseObject } from '../models/response-object.model';
import { ICountryRequestBody } from '../models/countriesRequestBody';

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  constructor(private http: HttpClient) {}

  isCurrentCountryCRC(currency: string) {
    return currency === CURRENCIES.CRC;
  }

  getAllCountries(requestBody: ICountryRequestBody): Observable<IResponseObject<ICountry[]>> {
    return this.http.post<IResponseObject<ICountry[]>>(
      `${environment.urlglobal_api}/services/services/paisesgenerales`,requestBody
    );
  }
}
